export { LockedSection } from './LockedSection';
export type { LockedSectionProps } from './LockedSection.types';
